import React from 'react';

import { AttentionMessage } from '@eika/attention-message';
import { LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import useTranslation from '../../hooks/useTranslation';
import { KidWithDashStages } from './Note';

interface Props {
    helpStatus: KidWithDashStages;
    handleAddDash: () => void;
}

const KidWithDashHelper: React.FC<Props> = ({ helpStatus, handleAddDash }) => {
    const translated = useTranslation();

    return (
        <>
            {helpStatus === KidWithDashStages.SHOW_MESSAGE && (
                <AttentionMessage
                    className="kid__help-with-dash"
                    type="warning"
                    text={translated.kidHelpWithDash.canHelp}
                    clickableItem={
                        <LinkButton onClick={handleAddDash}>{translated.kidHelpWithDash.addDash}</LinkButton>
                    }
                />
            )}
            {helpStatus === KidWithDashStages.GOT_HELP && (
                <AttentionMessage
                    className="kid__help-with-dash"
                    icon={IconTypes.USP_CHECKMARK_24}
                    text={translated.kidHelpWithDash.gotHelp}
                    type="success"
                />
            )}
        </>
    );
};

export default KidWithDashHelper;
